import { createEvent, createStore, sample } from 'effector'
import {
  NotificationPayload,
  showNotification,
} from 'src/features/notifications'
import { fx } from 'src/libs'
import { gatewayBlockChanged } from '../blockGateway'
import { allGatewaysUrl } from '../const'
import {
  AllGatewaysRequest,
  SystemGateway,
  SystemGatewayResponse,
} from './types'
import { buildAllGatewaysQuery, toSystemGateway } from './utils'

export const openAllGatewaysModal = createEvent()
export const closeAllGatewaysModal = createEvent()
export const allGatewaysLoad = createEvent<AllGatewaysRequest>()

export const getAllGatewaysFx = fx<void, SystemGatewayResponse>({
  method: 'GET',
  url: allGatewaysUrl,
})

export const $isAllGatewaysOpen = createStore(false)
  .on(openAllGatewaysModal, () => true)
  .reset(closeAllGatewaysModal)

export const $allGateways = createStore<SystemGateway[]>([])
  .on(getAllGatewaysFx.doneData, (_, response) =>
    response.body.items.map(toSystemGateway),
  )
  .reset(closeAllGatewaysModal)

export const $allGatewaysTotal = createStore<number>(0)
  .on(getAllGatewaysFx.doneData, (_, response) => response.body.total)
  .reset(closeAllGatewaysModal)

sample({
  clock: allGatewaysLoad,
  fn: (request) => ({ query: buildAllGatewaysQuery(request) }),
  target: getAllGatewaysFx,
})

sample({
  clock: gatewayBlockChanged,
  target: closeAllGatewaysModal,
})

sample({
  clock: getAllGatewaysFx.failData,
  fn: (error): NotificationPayload => ({
    type: 'error',
    description: error?.body?.message ?? 'Request failed',
  }),
  target: showNotification,
})
